import { defineComponent as _defineComponent } from 'vue'
import { ref, provide, readonly } from "vue"
import UserInvitationFlow from "@/modules/Users/Invitation/UserInvitation/UserInvitationFlow.vue"
import { InvitationType, InvitationState } from "@/modules/Users/Invitation/constants"
import useRouter from "@/router/useRouter"
import { FindInvitationQuery, FindInvitationQueryQuery, Invitation } from "@/gql"
import { useQuery } from "@vue/apollo-composable"
import { computed } from "vue"
import SubscriptionUserInvitationFlow from "@/modules/Users/Invitation/UserInvitation/SubscriptionUserInvitationFlow.vue"
import ConsultantInvitationFlow from "@/modules/Users/Invitation/ConsultantInvitation/ConsultantInvitationFlow.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'InvitationFlow',
  setup(__props) {

const { routes, navigateTo, router } = useRouter()

const invitationState = ref<string | null>(null)
const invitation = ref<Invitation | null>(null)

const { loading, onResult } = useQuery<FindInvitationQueryQuery>(FindInvitationQuery, {
  token: router.currentRoute.params?.token,
})

const invitationType = computed<InvitationType | null>(() => {
  if (invitation.value) {
    return invitation.value.type as InvitationType
  }
  return null
})

const productType = computed(() => {
  return invitation.value?.invitationForProduct.slug
})

onResult((result) => {
  if (result.data?.findInvitation) {
    invitation.value = result.data.findInvitation as Invitation
    invitationState.value = result.data.findInvitation.state
  }
})

provide("productType", readonly(productType))

return { __sfc: true,routes, navigateTo, router, invitationState, invitation, loading, onResult, invitationType, productType, UserInvitationFlow, InvitationType, InvitationState, SubscriptionUserInvitationFlow, ConsultantInvitationFlow }
}

})